import React from "react";
import { Box, Typography } from "@mui/material";

export interface RankingCardHeaderProps {
  /** Main title above subheader. Default: Radar Podscope */
  title?: string;
  /** Subtitle under the main title (e.g. "Programas por views promedio"). */
  subheader: string;
}

/** Shared header for ranking cards: title + configurable subheader. */
export const RankingCardHeader: React.FC<RankingCardHeaderProps> = ({
  title = "Radar Podscope",
  subheader,
}) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "12px",
      flexShrink: 0,
    }}
  >
    <Typography
      align="center"
      sx={{
        fontFamily: '"DM Serif Text", serif',
        fontSize: 48,
        lineHeight: "48px",
        color: "#fff",
      }}
    >
      {title}
    </Typography>
    <Typography
      align="center"
      sx={{
        fontFamily: '"DM Serif Text", serif',
        fontSize: 64,
        lineHeight: "62px",
        color: "#fff",
        padding: "0 16px",
        whiteSpace: "pre-line",
      }}
    >
      {subheader}
    </Typography>
  </Box>
);
